<template>
  <div class="user-UserSelector">
    <template v-if="disabled">
      <span class="text-primary">
        {{ findUser.map(o => o.name).join() }}
      </span>
    </template>
    <div
      v-else
      class="user-UserSelector_content"
      @click="handleVisible"
    >
      <span
        v-if="!value"
        class="placeholder"
      >
        <span>{{ placeholder }}</span>

        <feather-icon
          icon="ChevronDownIcon"
          class="placeholder-icon"
          size="20"
        />
      </span>
      <span
        v-else
        class="hasValue"
      >
        <!-- 选择器为多选时，选中人员展示 -->
        <div
          v-if="multiple"
          style="width: calc(100% - 50px);"
        >
          <a-tag
            v-for="(item, i) in findUser"
            :key="i"
            closable
            class="mt-0-5"
            @close="delCheckedUser($event, item.id)"
          >
            <!-- {{ item.enName }} -->
            {{ item.name }}
          </a-tag>
        </div>
        <!-- 选择器为单选时，选中人员展示 -->
        <span v-else>{{ findUser.map(o => o.name).join() }}</span>
        <feather-icon
          icon="XCircleIcon"
          class="hasValue-icon"
          size="16"
          @click.stop="clearValue"
        />
        <feather-icon
          icon="ChevronDownIcon"
          class="placeholder-icon"
          size="20"
        />
      </span>
    </div>

    <c-modal
      :visible="visible"
      title="User selector"
      size="lg"
      body-class="staff-selector-modal_body"
      footer-class="staff-selector-modal_footer"
      @close="close"
      @modelConfirm="handleModelConfirm"
      @confirmEnter="hoverConfirm = true"
      @confirmLeave="hoverConfirm = false"
    >
      <template slot="content">
        <div class="selector-content">
          <b-tabs
            v-model="currentTab"
            align="left"
          >
            <b-tab :title="'Search'" />
          </b-tabs>
          <div class="staff-search">
            <b-form-input
              v-model="searchUser"
              :placeholder="$t('_components.placeholder.input')+ 'user'"
              type="text"
            />
            <!-- or number -->
            <b-button
              v-if="currentTab === 0"
              variant="primary"
              size="sm"
              @click="handleSearchUser"
            >
              {{ i18n('btns.search') }}
            </b-button>
          </div>
          <!-- :class="{'staff-list__maxheight':( currentTab === 0), 'my-border__hover': staffLoaded}" -->
          <div
            class="staff-list my-border"
            :class="{'staff-list__maxheight':'my-border__hover'}"
          >
            <b-overlay
              :show="workerListLoading"
              rounded="sm"
              style="display: inline-block"
            >
              <div style="width: 100%;height: 100%">
                <template v-for="(item, i) in userData">
                  <div
                    :key="i"
                    class="staff-list__item"
                    :class="{'staff-list__item-checked': chcekedUser.indexOf(item.id) != -1}"
                    @click="handleUserClick(item)"
                  >
                    {{ item.name }} {{ item.account }}
                  </div>
                </template>
              </div>

            </b-overlay>

          </div>

          <div style="width: 100%;height: 30px;margin-top: 5px">
            <b-pagination
              v-model="navPage.currentPage"
              :total-rows="navPage.total"
              per-page="100"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              @change="navPageChange"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>

          <!-- :class="hoverConfirm ? (chcekedStaffResult.length>0 ? 'my-border__hover' : 'my-border__hover-wrning') : ''" -->
          <!-- 选中区域向左或向右移动 -->
          <div
            class="checked-staff my-border"
            :class="hoverConfirm ? (chcekedUserResult.length>0 ? 'my-border__hover' : 'my-border__hover-wrning') : ''"
          >
            <div class="checked-staff__btns">
              <div
                :class="chcekedUser.length>0 ? 'not-disabled':'is-disabled'"
                @click="handleMoveRes"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  size="20"
                />
              </div>
              <div
                :class="chcekedResUser.length>0 ? 'not-disabled':'is-disabled'"
                @click="handleClearRes"
              >
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="20"
                />
              </div>
            </div>
            <!-- 选中员工的数据展示 -->
            <div class="checked-staff__content">
              <template v-for="(item, i) in chcekedUserResult">
                <div
                  :key="i"
                  class="staff-list__item"
                  :class="{'staff-list__item-checked': chcekedResUser.indexOf(item.id) != -1}"
                  @click="handleResUserClick(item)"
                >
                  {{ item.name }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </c-modal>
  </div>
</template>

<script>
import TreeList from '@/components/treeList.vue'

import {
  BTab, BTabs, BOverlay, BFormCheckbox, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import { getList as getUserList } from '@/api/system/user';

import { deepClone } from '@/util/util';

export default {
  components: {
    CModal: () => import('@/components/crud/modal.vue'),
    BTab,
    BTabs,
    // TreeList,
    BOverlay,
    // BFormCheckbox,
    BFormInput,
    BButton,
    BPagination,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentTab: 1,
      visible: false,
      chcekedUser: [],
      chcekedUserResult: [],
      chcekedResUser: [],
      checkedUserData: [],
      userData: [],
      userAllData: [],
      hoverConfirm: true,
      navPage: {
        pageSize: 100,
        currentPage: 1,
        total: 12,
      },
      userLoading: false,
    }
  },
  computed: {
    findUser() {
      let find = []
      if (this.value) {
        const valArr = this.value.split(',')
        // 获取传入的值与所有的值的交集
        find = this.checkedUserData.filter(o => (valArr.includes(o.id.toString()))) || []
        if (find.length <= 0) {
          find = this.userAllData.filter(o => (valArr.indexOf(o.id.toString()) !== -1)) || []
        }
      }
      return find
    },
  },
  mounted() {
    // #TODO 可以优化做缓存处理
    if (this.value && this.userData.length <= 0) {
      this.userLoading = true
      const query = deepClone(this.option.dictQuery)
      getUserList(1, -1, { ids: this.value }).then(res => {
        this.userAllData = res.data.data.records
      })
      this.userLoading = false
    }
    this.getUserList()
  },
  methods: {
    handleVisible() {
      this.visible = true
    //   this.onload()
    },
    close() {
      this.visible = false
      this.hoverConfirm = false
    },
    clearValue() {
      this.chcekedUserResult = []
      this.chcekedResUser = []
      this.$emit('input', '')
    },
    handleResUserClick(e) {
      this.chcekedResUser = [e.id]
    },
    handleUserClick(e) {
      this.chcekedUser = [e.id]
    },
    async handleSearchUser() {
      // this.searchUser
      const res = await getUserList(this.navPage.currentPage, this.navPage.pageSize, { name: this.searchUser })
      const temp = res.data.data.records
      this.navPage.currentPage = res.data.data.current
      this.navPage.total = res.data.data.total
      this.navPage.size = res.data.data.size

      this.userData = temp
    },
    async navPageChange(e) {
      this.navPage.currentPage = e
      this.workerListLoading = true
      const res = await getUserList(this.navPage.currentPage, this.navPage.pageSize, { name: this.searchUser })
      this.workerListLoading = false
      const temp = res.data.data.records
      this.navPage.currentPage = res.data.data.current
      this.navPage.total = res.data.data.total
      this.navPage.size = res.data.data.size
      this.userData = temp
    },
    async getUserList(params) {
      // const res = await getUserList(1, 100, params)
      this.workerListLoading = true
      const res = await getUserList(this.navPage.currentPage, this.navPage.pageSize, params)
      this.workerListLoading = false
      const temp = res.data.data.records
      this.navPage.currentPage = res.data.data.current
      this.navPage.total = res.data.data.total
      this.navPage.size = res.data.data.size
      this.userData = temp
    },
    handleModelConfirm() {
      this.visible = false
      this.checkedUserData = this.chcekedUserResult
      const res = this.chcekedUserResult.map(o => o.id).join()

      this.$emit('input', res)
    },
    handleMoveRes() {
      const filter = this.userData.filter(o => this.chcekedUser.indexOf(o.id) !== -1)
      const temp = [...filter]
      this.chcekedUserResult = temp
      this.chcekedUser = []
      this.hoverConfirm = true
      setTimeout(() => {
        this.hoverConfirm = false
      }, 500);
    },
    delCheckedUser(e, id) {
      e.preventDefault();
      const temp = []
      this.chcekedUserResult.forEach(item => {
        if (item.id !== id) {
          temp.push(item)
        }
      })
      this.chcekedUserResult = [...temp]
      const res = temp.map(o => o.id).join()
      this.$emit('input', res)
    },
    handleClearRes() {
      const temp = []
      this.chcekedUserResult.forEach(item => {
        if (this.chcekedResUser.indexOf(item.id) === -1) {
          temp.push(item)
        }
      });
      this.chcekedUserResult = temp
      this.chcekedResUser = []
      this.hoverConfirm = true
      setTimeout(() => {
        this.hoverConfirm = false
      }, 500);
    },
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.user-UserSelector {
    padding: 0 2px;
    width: 100%;
    box-sizing: border-box;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    font-feature-settings: "tnum";
    position: relative;
    display: inline-block;
    outline: 0;
    &_content {
        display: block;
        cursor: pointer;
        padding: 0 15px 0 11px;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-top: 1.02px solid #d9d9d9;
        border-radius: 4px;
        outline: none;
        user-select: none;
        min-height: 2.714rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 2.714rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s;
        &:hover{
            box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
        }
        .placeholder, .hasValue{
            display: inline-block;
            position: relative;
            width: 100%;
            line-height: 20px;
            &-icon{
                position: absolute;
                color: #bfbfbf;
                right: 0;
                top: 50%;
                transform: translateY(calc(-50% + 2px));
                background-color: #FFF;
                z-index: 1;
            }
        }
        .placeholder{
            color: #bfbfbf;
        }
        .hasValue{
            color: rgba(0,0,0,.65);
            &-icon{
                color: #fff;
                transition: color .3s;
            }
        }
        &:hover{
            .hasValue{
                &-icon{
                    color: #bfbfbf;
                    transition: color .3s;
                    z-index: 2;
                    &:hover{
                        color: #797979;
                    }
                }
            }
        }
    }
}

.selector-content{
    height: 500px;
    .overlay-box{
        // height: 220px;
        height: 200px;
        width: calc(100% - 15px);
        overflow: auto;
        background-color: #FFF;
        padding:  5px 8px;
    }
    .tab-pane{
        width: 50%;
    }

    .staff-search{
        width: calc(50% - 15px);
        margin: 5px 0;
        display: flex;
        .btn{
          margin-left: 5px;
        }
    }

    .staff-list{
        margin-top: 10px;
        height: 200px;
        width: calc(50% - 15px);
        overflow: auto;
        background-color: #FFF;
        padding:  5px 4px;
        &__item{
            padding: 0 4px;
            margin: 2px 0;
            border-radius: 5px;
            &:hover, &-checked{
                background-color: #eee;
                cursor: pointer;
            }
            &-checked{
                color: #409EFF;
                background-color: #cae1fc !important;
            }
        }
        &__maxheight{
            height: 370px;
        }
    }

    .checked-staff{
        height: calc(100% - 71px);
        width: calc(50% - 28px);
        background-color: #FFF;
        padding:  5px 4px;
        position: absolute;
        left: calc(50% + 15px);
        top: 61px;
        &__btns{
            position: absolute;
            top: 50%;
            left: -25px;
            transform: translateY(-50%);
            width: 20px;
            &>div{
                width: 100%;
                border-radius: 5px;
                border: 1px solid #ddd;
                background-color: #FFF;
                padding: 5px 0;
                cursor: not-allowed;
            }
            &>div:first-child{
                margin-bottom: 10px;
            }
            .not-disabled{
                background-color: #409EFF;
                color: #FFF;
                cursor: pointer;
                &:hover{
                    background-color: #78aff9;
                }
            }
            .is-disabled{
                cursor: not-allowed;
            }
        }
        &__content{
            height: 100%;
            overflow: auto;
            padding:  5px 4px;
        }
        &::before{
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            border: 1px solid #ddd;
            border-radius: 5px;
            z-index: -1;
        }
    }
}

</style>

<style lang="scss">
.staff-selector-modal_body{
    background-color: #EEE;
    padding: 0.8rem 0.8rem !important;
    .custom-control.custom-checkbox{
      padding-left: 1.8rem;
    }
    .custom-control-label{
      cursor: pointer;
      width: 100%;
    }
}
</style>
